(function () {
    // find this section from the script tag
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`[id="${sectionID}"]`);

    // elements
    const player = section.querySelector(".socialVideoGridV1Player");
    const video = section.querySelector(".socialVideoGridV1PlayerVideo");
    const feed = section.querySelector(".socialVideoGridV1PlayerSwiper");
    const slides = [...section.querySelectorAll(".socialVideoGridV1PlayerSlide")];
    const shareDialog = section.querySelector(".socialVideoGridV1Share");
    const toast = section.querySelector(".socialVideoGridV1Toast");
    const MOBILE = window.matchMedia("(max-width: 800px)");

    // state
    let soundOn = false;
    let activeIndex = 0;
    let feedInView = false;
    let swiper = null;

    // clips already fetched ahead of time
    const warmed = new Set();

    /********************* Swiper *********************/

    // the desktop dialog uses swiper for the wheel, keys and arrows, phones scroll the feed natively so swipes stay smooth while video loads
    function setupSwiper() {
        if (MOBILE.matches) {
            if (swiper) {
                swiper.destroy(true, true);
                swiper = null;
            }
            return;
        }
        if (swiper) {
            return;
        }

        swiper = new Swiper(feed, {
            direction: "vertical",
            mousewheel: {
                forceToAxis: true,
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            navigation: {
                prevEl: section.querySelector(".socialVideoGridV1PlayerNavButton.prev"),
                nextEl: section.querySelector(".socialVideoGridV1PlayerNavButton.next"),
            },
            on: {
                slideChange: function () {
                    activateSlide(this.activeIndex);
                },
            },
        });
    }

    /********************* Playback *********************/

    // one shared video moves into the active slide, so sound stays on across swipes once a tap allows it
    function activateSlide(index) {
        activeIndex = index;
        const slide = slides[index];

        // cards and reviews have nothing to play, so the next clip warms up while they're read
        if (!slide.dataset.src) {
            video.pause();
            warmNext();
            return;
        }

        // moving a video element pauses it, so only move it when the slide changed
        if (video.parentElement !== slide) {
            video.parentElement.classList.remove("playing", "paused");
            slide.classList.remove("playing", "paused");
            slide.prepend(video);
        }
        video.muted = !soundOn;

        // only load and play when the viewer can see it
        if (!playerVisible()) {
            return;
        }
        startVideo();
    }

    // load the slide's clip if it isn't already, then play, falling back to muted when the browser blocks sound
    function startVideo() {
        const slide = video.parentElement;
        if (video.getAttribute("src") !== slide.dataset.src) {
            video.src = slide.dataset.src;
        }

        video.play().catch(error => {
            // a swipe or pause interrupted it, nothing to fix
            if (error.name !== "NotAllowedError") {
                return;
            }
            setSound(false);
            video.play().catch(() => slide.classList.add("paused"));
        });
    }

    // fetch the start of the next clip into the browser cache so swiping to it starts fast, without a second video decoding or the whole file downloading
    function warmNext() {
        if (!playerVisible()) {
            return;
        }

        const next = slides.slice(activeIndex + 1).find(slide => slide.dataset.src);
        if (!next || warmed.has(next.dataset.src)) {
            return;
        }
        warmed.add(next.dataset.src);
        fetch(next.dataset.src, { priority: "low", headers: { Range: "bytes=0-2097151" } }).then(response => response.blob()).catch(() => warmed.delete(next.dataset.src));
    }

    // pause whatever is playing
    function pauseVideo() {
        video.pause();
    }

    // desktop plays in the open dialog, mobile plays while the feed is on screen
    function playerVisible() {
        if (MOBILE.matches) {
            return feedInView;
        }
        return player.open;
    }

    // flip the sound and the icons that show it
    function setSound(on) {
        soundOn = on;
        video.muted = !on;
        player.classList.toggle("soundOn", on);
    }

    // hide the poster once frames are showing, then warm up the next clip
    video.addEventListener("playing", function () {
        this.parentElement.classList.add("playing");
        warmNext();
    });

    // move the progress bar with the clip
    video.addEventListener("timeupdate", function () {
        const bar = this.parentElement.querySelector(".socialVideoGridV1PlayerSlideProgressBar");
        if (!bar || !this.duration) {
            return;
        }
        bar.style.transform = `scaleX(${this.currentTime / this.duration})`;
    });

    // a tap turns sound on first, then pauses and plays
    slides.forEach(slide => {
        if (!slide.dataset.src) {
            return;
        }

        slide.addEventListener("click", function (event) {
            if (event.target.closest("a, button")) {
                return;
            }

            if (!soundOn) {
                setSound(true);
                return;
            }

            if (video.parentElement !== this || video.paused) {
                this.classList.remove("paused");
                startVideo();
                return;
            }
            video.pause();
            this.classList.add("paused");
        });
    });

    // the tap for sound prompt on the first video
    section.querySelectorAll(".socialVideoGridV1PlayerSlideSound").forEach(button => {
        button.addEventListener("click", function () {
            setSound(true);
        });
    });

    // the sound toggle in the top bar
    section.querySelector(".socialVideoGridV1PlayerTopSound").addEventListener("click", function () {
        setSound(!soundOn);
    });

    /********************* Mobile Feed *********************/

    // play while most of the feed is on screen, pause when it scrolls away
    const feedObserver = new IntersectionObserver(entries => {
        feedInView = entries[0].isIntersecting;

        // the header slides away so the feed gets the whole screen
        document.body.classList.toggle("videoFeedActive", feedInView && MOBILE.matches);

        if (!MOBILE.matches || !slides[activeIndex].dataset.src) {
            return;
        }

        if (!feedInView) {
            pauseVideo();
            return;
        }
        if (!slides[activeIndex].classList.contains("paused")) {
            activateSlide(activeIndex);
        }
    }, { threshold: 0.6 });

    // on phones the slide that fills most of the feed is the active one
    const slideObserver = new IntersectionObserver(entries => {
        if (!MOBILE.matches) {
            return;
        }
        entries.forEach(entry => {
            const index = slides.indexOf(entry.target);
            if (entry.isIntersecting && index !== activeIndex) {
                activateSlide(index);
            }
        });
    }, { root: feed, threshold: 0.6 });

    // where the feed was on the last scroll, to catch a scroll or fling that crosses it
    let lastTop = player.getBoundingClientRect().top;
    let leaving = false;

    // lock the page with the feed filling the screen, so swipes only move the videos
    function dock() {
        document.documentElement.classList.add("videoFeedLocked");
        window.scrollTo({ top: player.getBoundingClientRect().top + window.scrollY, behavior: "instant" });
        player.classList.remove("undocked");
        lastTop = 0;
    }

    // hand scrolling back to the page, drags on the feed scroll it until it docks again
    function undock() {
        document.documentElement.classList.remove("videoFeedLocked");
        player.classList.add("undocked");
    }

    // the page can't scroll past the feed from either side, reaching or crossing its top docks it
    function updateDocked() {
        if (!MOBILE.matches) {
            undock();
            return;
        }

        const top = player.getBoundingClientRect().top;
        const crossed = (lastTop > 0 && top < 0) || (lastTop < 0 && top > 0);
        lastTop = top;

        // an edge swipe is scrolling away, don't pull it back before it's clear
        if (leaving) {
            leaving = Math.abs(top) < 2;
            return;
        }

        if (Math.abs(top) < 2 || crossed) {
            dock();
        }
    }

    window.addEventListener("scroll", updateDocked, { passive: true });

    // where a swipe started, so only a swipe that begins on the first or last slide of a docked feed leaves it
    let touchStartY = 0;
    let touchAtStart = false;
    let touchAtEnd = false;

    feed.addEventListener("touchstart", function (event) {
        const docked = !player.classList.contains("undocked");
        touchStartY = event.touches[0].clientY;
        touchAtStart = docked && this.scrollTop <= 1;
        touchAtEnd = docked && this.scrollTop >= this.scrollHeight - this.clientHeight - 1;
    }, { passive: true });

    // past the first slide goes back to the top of the page, past the last goes on to what's below
    feed.addEventListener("touchend", function (event) {
        if (!MOBILE.matches) {
            return;
        }

        const distance = event.changedTouches[0].clientY - touchStartY;
        if (touchAtStart && distance > 40) {
            leaving = true;
            undock();
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }
        if (touchAtEnd && distance < -40) {
            leaving = true;
            undock();
            window.scrollTo({ top: player.getBoundingClientRect().bottom + window.scrollY, behavior: "smooth" });
        }
    });

    /********************* Desktop Player *********************/

    // open the player on the clicked tile, a click allows sound
    function openPlayer(index) {
        player.showModal();
        document.body.classList.add("noScroll");
        setSound(true);
        setupSwiper();
        swiper.update();
        swiper.slideTo(index, 0, false);
        activateSlide(index);
    }

    section.querySelectorAll(".socialVideoGridV1WallVideo").forEach(tile => {
        tile.addEventListener("click", function () {
            openPlayer(Number(this.dataset.index));
        });
    });

    // close from the button or the backdrop
    section.querySelector(".socialVideoGridV1PlayerClose").addEventListener("click", function () {
        player.close();
    });

    player.addEventListener("click", function (event) {
        if (event.target === this) {
            this.close();
        }
    });

    // escape, the button and the backdrop all land here, and closing stops the download too
    player.addEventListener("close", function () {
        video.pause();
        video.removeAttribute("src");
        video.load();
        video.parentElement.classList.remove("playing");
        document.body.classList.remove("noScroll");
    });

    // leaving the mobile layout with the feed playing, or entering it with the dialog open
    MOBILE.addEventListener("change", function () {
        if (player.open) {
            player.close();
        }
        pauseVideo();
        setupSwiper();
        updateDocked();
        document.body.classList.toggle("videoFeedActive", feedInView && MOBILE.matches);
    });

    /********************* Share *********************/

    // the page link, tagged so shares show up in analytics
    function shareLink() {
        const url = new URL(window.location.href);
        url.searchParams.set("utm_source", "video-lp");
        url.searchParams.set("utm_medium", "share");
        url.searchParams.set("utm_campaign", "share-page");
        return url.toString();
    }

    // phones get the native share sheet, everyone else picks text, email or copy
    async function sharePage() {
        const link = shareLink();
        const message = shareDialog.dataset.message;

        if (MOBILE.matches && navigator.share) {
            try {
                await navigator.share({ text: message, url: link });
            } catch (error) {
                // the viewer closed the share sheet
            }
            return;
        }

        // fill in the links and open the options
        shareDialog.querySelector(".socialVideoGridV1ShareButtonsText").href = `sms:?&body=${encodeURIComponent(`${message} ${link}`)}`;
        shareDialog.querySelector(".socialVideoGridV1ShareButtonsEmail").href = `mailto:?subject=${encodeURIComponent(shareDialog.dataset.subject)}&body=${encodeURIComponent(`${message}\n\n${link}`)}`;
        shareDialog.showModal();
    }

    section.querySelectorAll(".share").forEach(button => {
        button.addEventListener("click", function () {
            sharePage();
        });
    });

    // close from the button or the backdrop
    shareDialog.querySelector(".socialVideoGridV1ShareClose").addEventListener("click", function () {
        shareDialog.close();
    });

    shareDialog.addEventListener("click", function (event) {
        if (event.target === this) {
            this.close();
        }
    });

    // text and email open another app, so close behind them
    shareDialog.querySelectorAll(".socialVideoGridV1ShareButtonsText, .socialVideoGridV1ShareButtonsEmail").forEach(link => {
        link.addEventListener("click", function () {
            setTimeout(() => shareDialog.close(), 300);
        });
    });

    // copy the message and link
    shareDialog.querySelector(".socialVideoGridV1ShareButtonsCopy").addEventListener("click", async function () {
        try {
            await navigator.clipboard.writeText(`${shareDialog.dataset.message} ${shareLink()}`);
        } catch (error) {
            console.error(error);
            return;
        }

        shareDialog.close();
        showToast(shareDialog.dataset.copied);
    });

    // show a short message, then hide it
    function showToast(text) {
        toast.textContent = text;
        toast.showPopover();
        setTimeout(() => toast.hidePopover(), 2400);
    }

    /********************* Cards *********************/

    // the whole promo card acts like its button
    section.querySelectorAll(".socialVideoGridV1Card").forEach(card => {
        card.addEventListener("click", function (event) {
            const button = this.querySelector(".socialVideoGridV1CardButton");
            if (!button || event.target.closest("a, button")) {
                return;
            }
            button.click();
        });
    });

    // first paint: ready, so the spinner goes and the page below the feed shows, then watch for the feed with the first slide ready to play
    setupSwiper();
    undock();
    player.classList.add("active");

    // a scroll during loading stops on the feed, so if it's about there, lock it in place
    if (MOBILE.matches && Math.abs(player.getBoundingClientRect().top) < window.innerHeight / 4) {
        dock();
    }
    updateDocked();
    feedObserver.observe(player);
    slides.forEach(slide => slideObserver.observe(slide));
    activateSlide(0);
}());
